import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/list-doc.svg'


const _hoisted_1 = { class: "space-y-4 overflow-auto flex items-center gap-2" }
const _hoisted_2 = {
  key: 0,
  class: "border border-blue-lp-800 rounded-lg mt-4 pt-3 pb-3 h-full overflow-y-auto"
}
const _hoisted_3 = { class: "flex items-center gap-1.5 pr-3 pl-3 pb-2 border-b border-gray-lp-1400" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-6"
}, null, -1)
const _hoisted_5 = { class: "font-semibold text-sm" }
const _hoisted_6 = { class: "text-xs" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "font-bold text-black-lp-100" }
const _hoisted_9 = { class: "flex items-center gap-1.5" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "h-1 w-1 rounded-full bg-black-lp-100" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "h-1 w-1 rounded-full bg-black-lp-100" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "modal_cek_kendala",
    buttonId: "btn_close_modal_cek_kendala",
    class: "dialog-check-issue",
    modelValue: _ctx.openDialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDialog = $event)),
    title: _ctx.$t('pusatResolusi.cekKendala'),
    persistent: "",
    titleSize: "16",
    closeIcon: "x-gray-24",
    onReset: _ctx.cancelPopup,
    textColor: "text-gray-lp-300",
    showOverflow: ""
  }, {
    default: _withCtx(() => [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('pusatResolusi.checkModalLabel'),
            class: "w-full",
            fontSize: "14"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                id: "text_input_cek_kendala",
                class: "w-full",
                onChange: _ctx.onChangeSttNumber,
                modelValue: _ctx.sttNumber,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sttNumber = $event)),
                iconLeft: "ics_o_search",
                placeholder: _ctx.$t('pusatResolusi.checkModalPlaceHolder'),
                maxLength: 50,
                format: _ctx.formatRefNumber
              }, null, 8, ["onChange", "modelValue", "placeholder", "format"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_LpButton, {
            id: "btn_form_modal_cek_kendala",
            onClick: _ctx.onCheckIssue,
            customClass: "px-4 py-3 mt-1",
            title: _ctx.$t('pusatResolusi.checkNow'),
            textColor: "white",
            disabled: _ctx.isCheckDisable
          }, null, 8, ["onClick", "title", "disabled"])
        ]),
        (_ctx.tickets.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode("div", null, [
                  _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('pusatResolusi.create.sttNoIsReported')), 1),
                  _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('pusatResolusi.create.thereIs')) + " " + _toDisplayString(_ctx.tickets.length) + " " + _toDisplayString(_ctx.$t('pusatResolusi.create.problemReported')), 1)
                ])
              ]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tickets, (item, idx) => {
                return (_openBlock(), _createBlock("div", {
                  key: idx,
                  class: "flex flex-col"
                }, [
                  _createVNode("div", {
                    class: 
              `py-3 mr-3 ml-3 flex items-center gap-4 ${
                _ctx.tickets.length - 1 === idx ? '' : 'border-b border-gray-300'
              }`
            
                  }, [
                    _createVNode("div", _hoisted_7, [
                      _createVNode("div", _hoisted_8, _toDisplayString(item.caseType), 1),
                      _createVNode("div", _hoisted_9, [
                        _createVNode("span", null, " #" + _toDisplayString(item.caseNumber), 1),
                        _hoisted_10,
                        _createVNode("span", null, _toDisplayString(item.categoryName), 1),
                        _hoisted_11,
                        _createVNode("span", null, _toDisplayString(_ctx.mapStatusTicket(item.statusTicket).label), 1)
                      ])
                    ]),
                    _createVNode(_component_button_fill, {
                      title: _ctx.$t('pusatResolusi.create.seeDetail'),
                      class: "bg-blue-lp-600 p-2 font-semibold text-blue-lp-500 border-none",
                      onClick: ($event: any) => (_ctx.ticketSelect(item.id)),
                      style: {"width":"130px"}
                    }, null, 8, ["title", "onClick"])
                  ], 2)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onReset"]))
}